import { Component, HostBinding, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TenantService } from '@cloudia-shared/apis/generated/tenant-api';
import { Tenant } from '@cloudia-shared/tenant/tenant.service';
import { environment } from '@envs/environment';
import { TranslocoService, getBrowserLang } from '@ngneat/transloco';
import { BaseComponent } from '@tcp/cloudia-utilities';
import { AngularFaviconService } from 'angular-favicon';
import {
  KeycloakService
} from 'keycloak-angular';
import { take } from 'rxjs';

@Component({
  selector: 'cloudia-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit {
  @HostBinding('class.theme-cloudia') public cloudiaTheme: boolean;
  tenant: string;

  constructor(
    private titleService: Title,
    private ngxFavicon: AngularFaviconService,
    private readonly kc: KeycloakService,
    private readonly transloco: TranslocoService,
    private readonly tenantDataService: TenantService,
    public router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.unifyTenantName();
    this.enableThemes();
    this.titleService.setTitle(this.tenantDisplayName);
    this.ngxFavicon.setFavicon(this.getFavIconPath());
    if (this.kc.getKeycloakInstance()) {
      this.kc
        .getKeycloakInstance()
        .loadUserInfo()
        .then((x) => {
          const userProps = x as any;
          if (userProps.locale) {
            this.transloco.setActiveLang(userProps.locale);
          } else {
            this.transloco.setActiveLang(getBrowserLang());
          }
        })
        .catch(() => {
          this.transloco.setActiveLang(getBrowserLang());
        });
    } else {
      this.transloco.setActiveLang(getBrowserLang());
    }
  }

  enableThemes() {
    this.cloudiaTheme = this.tenantService.getTenant() === Tenant.cloudia;
  }

  getFavIconPath() {
    const env = environment?.localBackend ? 'LOCAL' : environment.env;
    return this.tenantConfig.faviconUrl[env];
  }

  async unifyTenantName() {
    this.tenantDataService.configuration.credentials = {
      bearerAuth: await this.kc.getToken(),
    };
    this.tenantDataService
      .getOriginalTenantName(this.tenant)
      .pipe(take(1))
      .subscribe({
        next: (value) => {
          const originalTenantName = value.name;
          if (originalTenantName !== this.tenant) {
            window.location.pathname = window.location.pathname.replace(
              this.tenant,
              value.name
            );
          }
        },
      });
  }
}
